import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Código promocional {{code}} aplicado',
  [COUPON_TYPES.CASHBACK]: 'Puntos de fidelidad aplicados',
  [COUPON_TYPES.REWARD]: 'Recompensa aplicada',
  [COUPON_TYPES.GIFT_CARD]: 'Tarjeta regalo aplicada',
};

export default Coupons;
